import React from "react";
import Modal from "react-bootstrap/Modal";
import "./model.css";
import Button from "react-bootstrap/Button";

const DivisionModal = ({
  show,
  onClose,
  selectedDivision,
  vfcData,
  formatAmount,
}) => {
  const sortedData = [...vfcData].sort((a, b) =>
    a.vfcName.localeCompare(b.vfcName)
  );

  return (
    <div className="divisionModel">
      <Modal
        show={show}
        onHide={onClose}
        dialogClassName="modal-90w"
        aria-labelledby="division-modal-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="division-modal-title">
            {`Loans and Recovery in ${selectedDivision} Division`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>VFC Name</th>
                    <th>Range Name</th>
                    <th>Total Loan Amount</th>
                    <th>Total Recovered Amount</th>
                    <th>Remaining Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.length > 0 ? (
                    sortedData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.vfcName}</td>
                        <td>{item.rangeName}</td>
                        <td>{formatAmount(item.totalLoanAmount)}</td>
                        <td>{formatAmount(item.totalRepaymentAmount)}</td>
                        <td>{formatAmount(item.remainingAmount)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DivisionModal;
